module.exports = __webpack_public_path__ + "static/media/ic_searchtype_mooring.f1f60134.svg";